// extracted by mini-css-extract-plugin
export var active = "_dx-2";
export var recordingDot = "_dx-1";
export var recordingIndicator = "_dx-0";